import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  wrapper: {
    flex: 1,
    width: 494,
    height: '100%',
  },
  topBar: {
    width: '100%',
    paddingVertical: 24,
    paddingLeft: 32,
    paddingRight: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.smoke,
  },
  iconClose: {
    width: 24,
    height: 24,
    padding: 4,
    color: neutrals.neutralGrays.ash,
  },
});
